var _path, _path2, _path3, _rect, _circle, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLaptop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "laptop",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 17,
    viewBox: "0 0 19 17",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M23,20H7a1,1,0,0,1-1-1V9A1,1,0,0,1,7,8H23a1,1,0,0,1,1,1V19A1,1,0,0,1,23,20Z",
    transform: "translate(-5.5 -7.5)",
    fill: "#1f9ed6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M23,29H7a1,1,0,0,1-1-1V26H24v2A1,1,0,0,1,23,29Z",
    transform: "translate(-5.5 -16.5)",
    fill: "#e7f0f3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M23.5,36h-3a.472.472,0,0,1-.5-.5v-4a.472.472,0,0,1,.5-.5h3a.472.472,0,0,1,.5.5v4A.472.472,0,0,1,23.5,36ZM21,35h2V32H21Z",
    transform: "translate(-12.5 -19)",
    fill: "#010101"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    width: 3.153,
    height: 3.783,
    transform: "translate(7.759 12.742)",
    fill: "#d8e5ea"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.631,
    cy: 0.631,
    r: 0.631,
    transform: "translate(9.02 10.22)",
    fill: "#010101"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M22.5,7H6.5A1.473,1.473,0,0,0,5,8.5v10A1.473,1.473,0,0,0,6.5,20h6v3H9.75a.5.5,0,0,0,0,1h9.5a.5.5,0,0,0,0-1H16.5V20h6A1.473,1.473,0,0,0,24,18.5V8.5A1.473,1.473,0,0,0,22.5,7ZM6,8.5A.472.472,0,0,1,6.5,8h16a.472.472,0,0,1,.5.5V16H6ZM15.5,23h-2V20h2ZM23,18.5a.472.472,0,0,1-.5.5H6.5a.472.472,0,0,1-.5-.5V17H23Z",
    transform: "translate(-5 -7)",
    fill: "#010101"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.ee1e32a6ab91f654edb2dc3eb9a94a9d.svg";
export { ForwardRef as ReactComponent };